import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

async function refundSend(state, { transactionId, reason, email }) {
  try {
    await HTTPService.refund(transactionId, reason, email);
    return true;
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
}

async function refundCommission({ commit }, publicId) {
  try {
    const { data } = await HTTPService.getRefundCommission(publicId);
    commit('SET_DATA', data);
  } catch (error) {
    logrocket.logger(error);
    commit('SET_DATA', {});
    throw new Error;
  }
}

async function refundDebit(state, { transactionId, cardId }) {
  try {
    await HTTPService.refundDebit(transactionId, cardId);
    return true;
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
}

async function refundBill(state, publicId) {
  try {
    const { data } = await HTTPService.refundBill(publicId);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
}

async function getRefundedTransaction(state, publicId) {
  try {
    const { data } = await HTTPService.getRefundedTransaction(publicId);
    state.commit('SELECT_TRANSACTION', data, { root: true });
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
}

export default {
  refundSend,
  refundCommission,
  refundDebit,
  refundBill,
  getRefundedTransaction,
};
